/**
 * useCityDetail — Städte-Detailseite (öffentlich, /cities/:id).
 */
import { useApi } from '../../lib/use-api'
import { fetchCity, type CityDetailResponse } from './citiesApi'

type UseCityDetailResult = {
  data: CityDetailResponse | undefined
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

export function useCityDetail(id: string, page = 1): UseCityDetailResult {
  const query = useApi<CityDetailResponse>(['city', id, page], async () => {
    const result = await fetchCity(id, { page })
    return result as { data?: CityDetailResponse; error?: unknown }
  })

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => query.refetch(),
  }
}
